"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackageRecipients = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
require("./PackageRecipients.scss");
var CopyButton_1 = require("@app/components/packages/CopyButton");
var matomo_1 = require("@app/shared/matomo");
var utils_1 = require("@app/shared/utils");
var PackageRecipient_1 = require("./PackageRecipient");
var initialState = {
    showExternal: false,
    showInternal: false
};
var PackageRecipients = /** @class */ (function (_super) {
    __extends(PackageRecipients, _super);
    function PackageRecipients() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = initialState;
        _this.hasDownloadedPackage = function (recipientEmail) {
            return _this.props.downloaders.includes(recipientEmail);
        };
        return _this;
    }
    PackageRecipients.prototype.componentDidMount = function () {
        var recipients = this.props.recipients;
        var externalRecipients = recipients.filter(function (r) { return !r.isInternal; });
        var internalRecipients = recipients.filter(function (r) { return r.isInternal; });
        var showInternal = (recipients.length > 0 && recipients.length < 3) || externalRecipients.length === 0;
        var showExternal = (recipients.length > 0 && recipients.length < 3) || internalRecipients.length === 0;
        this.setState({ showExternal: showExternal, showInternal: showInternal });
    };
    PackageRecipients.prototype.render = function () {
        var _this = this;
        var recipients = this.props.recipients;
        var externalRecipients = recipients.filter(function (r) { return !r.isInternal; });
        var internalRecipients = recipients.filter(function (r) { return r.isInternal; });
        /* Functions - BEGIN */
        var copyRecipients = function () {
            new matomo_1.MatomoTracker().trackEvent('Package Details', 'Copy Recipients');
            return utils_1.getAllRecipients(recipients);
        };
        var handleExternalExpand = function () {
            _this.setState(__assign(__assign({}, _this.state), { showExternal: !_this.state.showExternal }));
        };
        var handleInternalExpand = function () {
            _this.setState(__assign(__assign({}, _this.state), { showInternal: !_this.state.showInternal }));
        };
        /* Functions - END */
        /* Defined Elements - BEGIN */
        var copyRecipientsElement = react_1.default.createElement(CopyButton_1.CopyButton, { copyId: 'copyBtn', onCopy: copyRecipients, showTooltip: true, subject: 'recipients', tooltipPosition: 'is-tooltip-left' });
        /* Defined Elements - END */
        return (react_1.default.createElement(react_1.default.Fragment, null,
            internalRecipients.length > 0 &&
                react_1.default.createElement("div", { className: "card recipients internal-recipients" },
                    react_1.default.createElement("div", { className: "card-header", onClick: handleInternalExpand },
                        react_1.default.createElement("span", { className: "icon toggle-icon" },
                            react_1.default.createElement("i", { className: classnames_1.default('fas', { 'fa-chevron-down': this.state.showInternal }, { 'fa-chevron-right': !this.state.showInternal }) })),
                        react_1.default.createElement("p", { className: "card-header-title help" },
                            "Internal (",
                            internalRecipients.length,
                            ")"),
                        copyRecipientsElement),
                    react_1.default.createElement("div", { className: classnames_1.default('card-content', { hidden: !this.state.showInternal }) }, internalRecipients.map(function (r) { return react_1.default.createElement(PackageRecipient_1.PackageRecipient, { recipient: r, key: r.userEmail, hasDownloadedPackage: _this.hasDownloadedPackage(r.userEmail) }); }))),
            externalRecipients.length > 0 &&
                react_1.default.createElement("div", { className: "card recipients internal-recipients" },
                    react_1.default.createElement("div", { className: "card-header", onClick: handleExternalExpand },
                        react_1.default.createElement("span", { className: "icon toggle-icon" },
                            react_1.default.createElement("i", { className: classnames_1.default('fas', { 'fa-chevron-down': this.state.showExternal }, { 'fa-chevron-right': !this.state.showExternal }) })),
                        react_1.default.createElement("p", { className: "card-header-title help" },
                            "External (",
                            externalRecipients.length,
                            ")"),
                        internalRecipients.length === 0 ? copyRecipientsElement : null),
                    react_1.default.createElement("div", { className: classnames_1.default('card-content', { hidden: !this.state.showExternal }) }, externalRecipients.map(function (r) { return react_1.default.createElement(PackageRecipient_1.PackageRecipient, { recipient: r, key: r.userEmail, hasDownloadedPackage: _this.hasDownloadedPackage(r.userEmail) }); })))));
    };
    return PackageRecipients;
}(react_1.Component));
exports.PackageRecipients = PackageRecipients;
